<!-- <div [ngStyle]="{'display' : listDisplay ? 'block' : 'none'}"> -->
  <div [ngStyle]="{'display' : listDisplay ? 'block' : 'none'}">
    <div [ngStyle]="{'display' : display ? 'block' : 'none'}">
      <div class="content-wrapper">
        <div>
          <div>
            <div>
              <div class="btn-wrapper">
                <button mat-flat-button class="btn-back btn-warn" color="" aria-label="Back" (click)='back()'>
                  <span>{{'questions.typeOfQuestions.standard.btnBack' | translate}}</span>
                </button>
                <span class="spacer"></span>
                <button mat-flat-button color="" class="btn-primary" aria-label="Save" (click)='saveQuestion()' [disabled]="allPoints.length < 2 || addQuestionForm.invalid">
                  <span>{{'questions.typeOfQuestions.standard.btnSave' | translate}}</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="filter-section">
          <div class="body-section title">
            <mat-icon>library_add</mat-icon> &nbsp;
            <span>{{'questions.typeOfQuestions.hotspotMultiChoiceQuestion.title' | translate}}</span>
          </div>
        </div>
        <form [formGroup]="addQuestionForm">
          <div class="editor1">
            <label class="que-label">{{'questions.typeOfQuestions.standard.labelQuest' | translate}}</label>
            <ckeditor #myEditor formControlName="question" [editor]="Editor" (ready)="onReady($event)"></ckeditor>
            <div *ngIf="errorMsg" class="alert alert-danger">{{ errorMsg }}</div>
          </div>
        </form>
        <div *ngIf="showQuestionError" class="text-msg">
          <span>{{'questions.typeOfQuestions.standard.errorQuestion' | translate}}</span>
        </div>
        <div class="filter-section">
          <div class="body-section title">
            <div class="">
              <span>{{'questions.typeOfQuestions.hotspotMultiChoiceQuestion.image' | translate}}</span>
            </div>
          </div>
        </div>

        <div class="main-content-wrapper">
          <div class="dropzone" fileDragDrop (filesChangeEmiter)="onFileSelected($event)">
            <div class="text-wrapper">
              <div class="centered">
                <div class="file-input-button">
                  <input type="file" name="file" id="file" (change)="onFileSelected($event)" multiple  [(ngModel)]="filetext">
                  <span class="btn-upload">{{'questions.typeOfQuestions.hotspotQuestion.uploadImage' | translate}}</span>
                </div>
                <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>
              </div>
            </div>
          </div>
          <!-- <input type="file" name="file" id="file" (change)="onFileSelected($event)" multiple> -->
          <!-- <button mat-raised-button color="primary" (click)="onUpload()"
          [ngClass]="{'disableBtn' : !uploadBtn}">Upload image</button> -->
          <span class="error-message">{{uploadImgError}}</span>
        </div>

        <div class="preview-image">
          <div class="image-wrapper" *ngIf="imageUrl">
            <img src="{{imageUrl}}" alt="">
          </div>
        </div>

        <div class="filter-section">
          <div class="body-section title">
            <div class="">
              <span>{{'questions.typeOfQuestions.hotspotMultiChoiceQuestion.HighlightHotspot' | translate}}</span>
            </div>
          </div>
        </div>

        <div class="hotspot-area">
          <div class="action-btns">
            <div class="row">
              <div class="col-sm-1 button-width" [ngClass]="{'drawcolor': drawingArrow}">
                <div class="draw-width">
                  <button mat-icon-button (click)="drawShape(false)" [disabled]="imageUrl == ''">
                    <span [ngClass]="{'pencilColor': imageUrl == ''}"><img src="../../../../assets/pencil.png" width="35px" alt="draw">&nbsp;</span>
                    <span class="Icon-Label">{{'questions.typeOfQuestions.hotspotMultiChoiceQuestion.Draw' | translate}}</span>
                  </button>
                </div>
              </div>
              <div class="col-sm-1 button-width" [ngClass]="{'drawcolor': deletecolor}">
                <button mat-icon-button (click)="deleteShape(true)" [disabled]="imageUrl == ''">
                  <mat-icon style="font-size: 30px;">delete</mat-icon>&nbsp;
                  <span class="Icon-Label">{{'questions.typeOfQuestions.hotspotQuestion.Delete' | translate}}</span>
                </button>
              </div>
              <div class="col-sm-1 zoomin-width">
                <button mat-icon-button (click)="ZoomIn(false)" [disabled]="imageUrl == ''">
                  <mat-icon style="font-size: 35px;">zoom_in</mat-icon>
                </button>
              </div>
              <div class="col-sm-1 zoomout-width">
                <button mat-icon-button (click)="ZoomOut(true)" [disabled]="imageUrl == ''">
                  <mat-icon  style="font-size: 35px;">zoom_out</mat-icon>
                </button>
              </div>
              <div class="col-sm-6"></div>
              <div class="col-sm-1 button-width">
                <div class="undo-width">
                  <button mat-icon-button (click)="undoShape()" [disabled]="this.history.length ==0">
                    <mat-icon>undo</mat-icon>&nbsp;
                    <span>{{'questions.typeOfQuestions.hotspotQuestion.Undo' | translate}}</span>
                  </button>
                </div>
              </div>
              <!--<div class="col-sm-1 button-width">
                <button mat-icon-button (click)="redo()" [disabled]="allPoints.length != 0">
                  <mat-icon>redo</mat-icon>&nbsp;
                  <span>Redo</span>
                </button>
              </div> -->
            </div>
          </div>
          <div class="area">
            <!-- <div class="container-fluid mb-4 "> -->
            <div class="area-draw">
              <pan-zoom [config]="PanZoomConfig ">
                <div style="position: relative;">
                  <div class="artboard" (mouseup)="mouseUp($event)" (mousemove)="mouseMove($event)" #artboard>
                  </div>
                </div>
              </pan-zoom>
            </div>
            <!-- </div> -->
          </div>
        </div>

        <div class="color-section" *ngIf="allPoints.length > 0">
          <div class="body-section title">
            <div class="">
              <span>{{'questions.typeOfQuestions.hotspotMultiChoiceQuestion.color' | translate}}</span>
            </div>
          </div>
          <div class="color-pallete">
            <div class="row align-icons">
              <div class="col-md-4">
                <mat-checkbox [(ngModel)]="hotspotColor">
                  {{'questions.typeOfQuestions.hotspotQuestion.checkboxText' | translate}}
                </mat-checkbox>
              </div>
              <div class="col-md-4">
                {{'questions.typeOfQuestions.hotspotMultiChoiceQuestion.fillColor' | translate}}
                <input readonly [(colorPicker)]="color" [style.background]="color" (colorPickerChange)="onChangeColor($event)" />
              </div>
              <div class="col-md-4">
                {{'questions.typeOfQuestions.hotspotMultiChoiceQuestion.outLineColor' | translate}} <input readonly [(colorPicker)]="color1" [style.background]="color1"
                  (colorPickerChange)="onChangeBorderColor($event)" />
              </div>
            </div>
          </div>
        </div>

        <div class="add-option-main" *ngIf="allPoints.length > 0">
          <div>
            <label class="Questions-score">{{'questions.typeOfQuestions.TrueOrFalse.labelQuestScore' | translate}}</label>
            <input min="0" value="newEvent" [(ngModel)]="newEvent" class="form-control scoreInput" readonly
              (keypress)="keyPressNumbers($event)">
          </div>

            <div class="score-wrapper">
              <label class="mrg-top">{{'questions.typeOfQuestions.hotspotMultiChoiceQuestion.optionScore' | translate}}</label>
              <div class="add-option" *ngFor="let o of allPoints; let i = index">
                <div class="input-class-container">
                  <mat-checkbox [checked]="o?.answerValid==true" (change)="onCheckRadioOption(o, $event)"> </mat-checkbox>
                  <input type="number" (change)="addScore(o, $event)" class="form-control optionInput" min="0" max="9999.99" step=".01"
                    value="" [(ngModel)]="o.correctPoints" (input)="validateInput($event, o, 'options')" (keypress)="omit_special_char($event)">
                  <!-- <input type="number" min="0" max="9999" onkeydown="if(event.key==='.'){event.preventDefault();}"
                    oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"
                    onkeypress="if(this.value.length == 4 ) return false;" [(ngModel)]="o.correctPoints" value="" class="form-control optionInput" (change)="addScore(o, $event)"> -->
                  <ng-component class="optionss" innerHTML="{{'questions.typeOfQuestions.hotspotMultiChoiceQuestion.hotspotLabel' | translate}} {{i + 1}}">
                  </ng-component>
                  <!-- <div class="mat-icon-div">
                    <button mat-icon-button matTooltip="edit">
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button mat-icon-button matTooltip="delete">
                      <mat-icon>delete_outline</mat-icon>
                    </button>
                  </div> -->
                </div>
              </div>
            </div>
        </div>

        <div class="exp-panel">
          <mat-accordion>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{'questions.typeOfQuestions.standard.accordian.title' | translate}}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <form [formGroup]="moreOptionForm">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-md-2">
                      <div class="scoring-check">
                        <mat-checkbox name="autoscoring" formControlName="autoscore" [checked]="autoscoring"
                          [disabled]="true"><b>{{'questions.typeOfQuestions.standard.accordian.checkbox' |
                            translate}}</b>
                        </mat-checkbox>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="scoring-check">
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-2">
                      <div class="form-label">
                        <label>{{'questions.typeOfQuestions.standard.accordian.selectOptions.option1.label' |
                          translate}}</label>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <mat-form-field class="scoring-type" appearance="fill"
                        [hideRequiredMarker]="hideRequiredControl.value" [floatLabel]="floatLabelControl.value">
                        <mat-select formControlName="scoringTypeMatch" [(value)]="getscoringtype">
                          <mat-option [value]="option.id == 1 ? 'true' : 'false'"
                            *ngFor="let option of QuestionScoringType">{{option.title}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>

                    <div class="col-md-2">
                      <div class="form-label score-labels1">
                        <label required>{{'questions.typeOfQuestions.standard.accordian.selectOptions.option4.label'
                          | translate}}</label>
                      </div>
                    </div>
                    <div class="col-md-3 minimumScore">
                      <input type="number" class="form-control penalty-points" formControlName="minimumScoreIfAttempt" (keypress)="omit_special_char($event)"
                        min="0" max="9999.99" step=".01" (input)="validateInput($event, moreOptionForm.controls, 'minimumScore')">
                      <!-- <input min="0" class="form-control penalty-points" formControlName="minimumScoreIfAttempt"
                        type="number" onkeypress="if(this.value.length == 4 ) return false;"
                        oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"> -->
                      <div *ngIf="moreOptionForm.controls.minimumScoreIfAttempt.errors"
                        class="alert alert-danger w-75 zero">
                        <div *ngIf="moreOptionForm.controls.minimumScoreIfAttempt.errors.required">
                          {{'questions.typeOfQuestions.standard.accordian.selectOptions.option4.errorMsg1' |
                          translate}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    </div>
    <div *ngIf="!display">
      <app-choose-question-type></app-choose-question-type>
    </div>
  </div>

  <div *ngIf="!listDisplay">
    <app-question-list></app-question-list>
  </div>
    <!-- </div> -->



      <!-- <div [ngStyle]="{'display' : !listDisplay ? 'block' : 'none'}">
        <app-question-list></app-question-list>
      </div> -->
